import React, { useEffect, useState } from 'react';
import * as PR from '../../prime-react';
import { getLatestRelease } from '../../utils/releaseNotes';
import { useSelector } from 'react-redux';
import './ReleaseNotesModal.scss';

const ReleaseNotesModal = () => {
  const [visible, setVisible] = useState(false);
  const [latestRelease, setLatestRelease] = useState(null);

  const sessionId = useSelector((state) => state?.auth?.sessionData?.sessionId);
  const isAnalyst = useSelector((state) => state.auth.role) === "analyst";

  useEffect(() => {
    if (!sessionId) return;

    const release = getLatestRelease();
    if (!release) return;

    const currentVersion = process.env.REACT_APP_VERSION;
    const cachedVersion = localStorage.getItem('releaseVersion');

    if ((!cachedVersion || cachedVersion !== currentVersion) && isAnalyst) {
      setLatestRelease(release);
      setVisible(true);
      localStorage.setItem('releaseVersion', currentVersion);
    }
  }, [sessionId, isAnalyst]);

  const handleClose = () => {
    setVisible(false);
  };

  if (!latestRelease) return null;

  const headerContent = (
    <div className="flex align-items-center gap-2 flex-wrap">
      <i className="pi pi-sparkles text-xl header-star-icon"></i>
      <span className="font-bold text-lg md:text-xl text-color">What's New in {latestRelease.version}</span>
      <PR.Badge value="NEW RELEASE" className="new-release-badge ml-1" />
    </div>
  );

  const footerContent = (
    <div className="release-modal-footer flex flex-column sm:flex-row align-items-center justify-content-between gap-3 w-full">
      <a
        href="https://bluehouse-technology.co.uk"
        target="_blank"
        rel="noopener noreferrer"
        className="bluehouse-link flex align-items-center gap-1 font-medium text-xs"
      >
        <span>Developed by Bluehouse Technology</span>
        <i className="pi pi-external-link text-xs"></i>
      </a>
      <div className="flex align-items-center gap-2 flex-wrap justify-content-end">
        <PR.Button
          label="Got it"
          icon="pi pi-check"
          className="p-button-sm yellow-btn"
          onClick={handleClose}
          autoFocus
        />
      </div>
    </div>
  );

  return (
    <PR.Dialog
      header={headerContent}
      visible={visible}
      style={{ width: '90vw', maxWidth: '540px' }}
      footer={footerContent}
      onHide={handleClose}
      className="release-notes-modal"
      dismissableMask
    >
      <div className="release-modal-content py-2">
        <div className="flex align-items-center gap-2 text-sm text-color-secondary mb-3">
          <i className="pi pi-calendar text-xs"></i>
          <span>Released on: {latestRelease.date}</span>
        </div>

        <div className="surface-card p-3 border-round border-1 surface-border">
          <h4 className="m-0 mb-2 font-semibold text-color">Release Highlights</h4>
          {Array.isArray(latestRelease.notes) ? (
            <ul className="release-highlights-list m-0 pl-3">
              {latestRelease.notes.map((note, index) => (
                <li key={index}>{note}</li>
              ))}
            </ul>
          ) : (
            <p className="release-highlights-text m-0">{latestRelease.notes}</p>
          )}
        </div>
      </div>
    </PR.Dialog>
  );
};

export default ReleaseNotesModal;
